import * as Sentry from '@sentry/browser'; // eslint-disable-line import/no-namespace

const addBreadcrumb = breadcrumb => {
  Sentry.addBreadcrumb(breadcrumb);
};

export default addBreadcrumb;
